
import { configureStore, combineReducers } from '@reduxjs/toolkit'
import thunk from 'redux-thunk'
import persistState from 'redux-sessionstorage'

import reducers from './reducers'

const sessionStorageConfig = {
  key: 'saas-boost-session',
}

const store = configureStore({
  reducer: reducers,
  middleware: [thunk],
  enhancers: [persistState('session', sessionStorageConfig)],
})

export default store
